import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import propertyMasterDraftComponent from '../../biz/propertyMasterDraftBiz'

const initialState = {
    search: []
}


export const fetchSearchProperty = createAsyncThunk('master/fetchSearchProperty', async ({agentId, val, status, paging}) => {
    const search = await propertyMasterDraftComponent.search(agentId, val, status, paging)
    return search;
})

export const masterDraft = createSlice({
    name: 'master',
    initialState,
    reducers: {
        updateMasterDraft: (state, action) => {
            return {
                ...action.payload,
            }
        },
    },

    extraReducers(builder) {
        builder
            .addCase(fetchSearchProperty.fulfilled, (state, action) => {
                state.search = action.payload
            })
    }
})

// export const { updateMasterDraft } = masterDraft.actions

export default masterDraft.reducer